
import { Component, Vue } from 'vue-property-decorator';
import MainCard from './components/MainCard.vue';
import { Chart } from 'highcharts-vue';
import { ClientConstants } from './client.constants';
import PageHeader from './components/PageHeader.vue';
import PageFooter from './components/PageFooter.vue';

@Component({ components: { MainCard, highcharts: Chart, PageHeader, PageFooter } })
export default class App extends Vue {
    mounted() {
        let glanceScript = document.createElement('script');
        glanceScript.type = 'text/javascript';
        let glanceUrl = '';
        switch (process.env.NODE_ENV) {
            case 'development': {
                glanceUrl = ClientConstants.GLANCE_URL_DEV;
                break;
            }
            case 'test': {
                glanceUrl = ClientConstants.GLANCE_URL_QA;
                break;
            }
            case 'production': {
                glanceUrl = ClientConstants.GLANCE_URL_PROD;
                break;
            }
            default: {
                glanceUrl = ClientConstants.GLANCE_URL_DEV;
                break;
            }
        }
        glanceScript.src = glanceUrl;
        document.head.appendChild(glanceScript);
    }
}
